import { jsx as _jsx } from "react/jsx-runtime";
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './Editor_PertinentCategory.scss';
export const Editor_PertinentCategory = (props) => {
    return _jsx(LL_V_L, { className: 'e__pertinent-category', children: _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(DefaultEditor_InputText, { editable: props.editable, prop: 'label', disabled: !props.editMode }) }) });
};
//# sourceMappingURL=Editor_PertinentCategory.js.map